import {EnvTypes, withSystem} from '@packages/systems/wfdl';
import {functionOf, TListOfElement, TText} from '@packages/systems/wfdl-ast';

export const textToListOfElements: EnvTypes.UnsafeTypedValue = {
  envType: {
    dataType: functionOf(withSystem({isBindable: true}, TText), TListOfElement),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  value: (text: string) => {
    if (typeof text !== 'string') return [];
    return [
      {
        text: true,
        type: null,
        id: 'temp',
        children: [],
        data: {value: text},
      },
    ];
  },
};
